/**
 * The console agent's published identity.
 *
 * These are the ids `asab-agents/cmd/seed-marketplace` publishes, fixed there so
 * republishing keeps an org's installation pointing at the same agent. They are
 * needed here for two things: elevation mints against the catalog entry, and the
 * executor refuses writes whose arguments name either of them, which is what
 * stops the console uninstalling or rewriting itself mid-conversation.
 */
export const CONSOLE_CATALOG_ID = 'cat_console_agent';
export const CONSOLE_AGENT_ID = 'agent_platform_console';

/** Also matched, because the catalog accepts a slug wherever it accepts an id. */
export const CONSOLE_CATALOG_SLUG = 'console-agent';

/** Everything a console write must never name. */
export const CONSOLE_PROTECTED_IDS = [
  CONSOLE_CATALOG_ID,
  CONSOLE_AGENT_ID,
  CONSOLE_CATALOG_SLUG,
];
